import { MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { SITE, whatsappLink } from "@/lib/site";

type BookBarProps = {
  /** Slides the bar away (lightbox open, near the booking CTA itself, etc). */
  hidden?: boolean;
  className?: string;
};

/**
 * Slim always-there WhatsApp prompt that sits directly above the bottom tabs.
 * Appears once the visitor is past the hero, so the first impression stays clean.
 */
export function BookBar({ hidden = false, className }: BookBarProps) {
  return (
    <div
      className={cn(
        "safe-bottom fixed inset-x-0 bottom-16 z-40 px-3 transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] lg:hidden",
        hidden
          ? "pointer-events-none translate-y-6 opacity-0"
          : "pointer-events-auto translate-y-0 opacity-100",
        className,
      )}
    >
      <a
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-11 items-center justify-center gap-2.5 overflow-hidden rounded-full bg-foreground font-sans text-[0.625rem] tracking-[0.22em] text-background uppercase shadow-[0_8px_28px_rgba(0,0,0,0.18)] active:scale-[0.98] transition-transform"
      >
        <MessageCircle className="h-3.5 w-3.5 shrink-0" strokeWidth={1.5} />
        <span className="relative">
          Book with {SITE.name.split(" ")[0]}
          {/* shimmer sweep across the label */}
          <span
            aria-hidden="true"
            className="animate-shimmer-sweep pointer-events-none absolute inset-0 bg-linear-to-r from-transparent via-ivory/25 to-transparent"
            style={{ animationDuration: "3.4s" }}
          />
        </span>
      </a>
    </div>
  );
}
